/** The exact mount point expected by the original reader component library. */
export function AppViewport() {
  return <div id="app" />;
}
